<template>
    <div id="Critical-Shortages" class="wrapper m0-50 critical">
        <div class="section">
            <div class="div-block-15">
                <div class="form-container">
                    <div class="form-block w-form">
                        <form v-if="!success&&!fail" id="wf-form-Request-Finished-Units---Hand-Sanitizer" name="wf-form-Request-Finished-Units---Hand-Sanitizer" data-name="Request Finished Units - Hand Sanitizer" class="form-wrapper"
                              @submit.prevent="submit">
                            <div class="form-title-container">
                                <div class="form-title">Request Finished Units - Hand Sanitizer<a href="https://prospero-uikit.webflow.io/2-content#"><strong><br></strong></a></div>
                                <p>Please review the <a href="https://buyandsell.gc.ca/specifications-for-COVID-19-products#600" target="_blank" class="link-blue">Government of Canada&#x27;s Product Specifications</a> prior to completing the form below.</p>
                            </div>
                            <div class="input-container"><label class="input-group-label">Delivery Information</label>
                                <div class="input-container">
                                    <label for="Facility-Street-Address" class="input-label">Facility Street Address</label>
                                    <input v-model="form.requiredAtStreetAddress"
                                           @blur="$v.form.requiredAtStreetAddress.$touch()"
                                           type="text" class="text-input w-input" autofocus="true" maxlength="256" name="Facility-Street-Address" data-name="Facility Street Address" placeholder="Street Address" id="Facility-Street-Address">
                                    <div class="text-red" v-if="$v.form.requiredAtStreetAddress.$error">
                                        <div v-if="!$v.form.requiredAtStreetAddress.required">A street adress is required</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <div class="w-row">
                                        <div class="upper-input-container w-col w-col-6">
                                            <label for="Facility-City" class="input-label">City</label>
                                            <input v-model="form.requiredInCity"
                                                   @blur="$v.form.requiredInCity.$touch()"
                                                   type="text" class="text-input w-input" maxlength="256" name="Facility-City" data-name="Facility City" placeholder="City" id="Facility-City">
                                            <div class="text-red" v-if="$v.form.requiredInCity.$error">
                                                <div v-if="!$v.form.requiredInCity.required">A city is required</div>
                                            </div>
                                        </div>
                                        <div class="lower-input-container w-col w-col-6">
                                            <label for="Facility-Postal-Code" class="input-label">Postal Code</label>
                                            <input v-model="form.requiredAtPostalCode"
                                                   @blur="$v.form.requiredAtPostalCode.$touch()"
                                                   type="text" v-mask="'S#S#S#'" class="text-input w-input" maxlength="256" name="Facility-Postal-Code" data-name="Facility Postal Code" placeholder="A1A 1A1" id="Facility-Postal-Code">
                                            <div class="text-red" v-if="$v.form.requiredAtPostalCode.$error">
                                                <div v-if="!$v.form.requiredAtPostalCode.required">A postal code is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label for="Facility-Province" class="input-label">Province</label>
                                    <select v-model="form.requiredInState"
                                            @blur="$v.form.requiredInState.$touch()"
                                            id="Facility-Province" name="Facility-Province" data-name="Facility Province" class="w-select">
                                        <option value="">Select one...</option>
                                        <option value="AB">Alberta</option>
                                        <option value="BC">British Columbia</option>
                                        <option value="MB">Manitoba</option>
                                        <option value="NB">New Brunswick</option>
                                        <option value="NL">Newfoundland and Labrador</option>
                                        <option value="NS">Nova Scotia</option>
                                        <option value="NT">Northwest Territories</option>
                                        <option value="NU">Nunavut</option><option value="Ontario">Ontario</option>
                                        <option value="PE">Prince Edward Island</option>
                                        <option value="QC">Quebec</option>
                                        <option value="SK">Saskatchewan</option>
                                        <option value="YT">Yukon</option>
                                    </select>
                                    <div class="text-red" v-if="$v.form.requiredInState.$error">
                                        <div v-if="!$v.form.requiredInState.required">A province must be selected</div>
                                    </div>
                                </div>
                            </div>
                            <div class="input-container"><label  class="input-group-label">Request Details</label>
                                <div class="input-container">
                                    <label class="input-label">Requestor Type</label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Public Healthcare" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Public Healthcare">
                                        <span class="checkbox-label w-form-label">Public Healthcare</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Private Healthcare" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Private Healthcare">
                                        <span class="checkbox-label w-form-label">Private Healthcare</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Emergency Services" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Emergency Services">
                                        <span class="checkbox-label w-form-label">Emergency Services</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Essential Business" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Essential Business">
                                        <span class="checkbox-label w-form-label">Essential Business</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Distributor" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Distributor">
                                        <span class="checkbox-label w-form-label">Distributor</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Retailer" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Retailer">
                                        <span class="checkbox-label w-form-label">Retailer</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestorType" type="radio" id="Non-Essential Business" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Non-Essential Business">
                                        <span class="checkbox-label w-form-label">Non-Essential Business</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field other">
                                        <div>
                                            <input v-model="form.requestorType" type="radio" id="Other" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="other">
                                            <input v-model="form.otherRequestorType" type="text" placeholder="Other" class="text-input w-input" maxlength="256" id="Other-Delivery-Method-Description" style="padding-left: 10px">
                                        </div>
                                    </label>
                                    <div class="text-red" v-if="$v.form.requestorType.$error">
                                        <div v-if="(!$v.form.requestorType.sometimesRequired)">A requestor type is required</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label for="Description" class="input-label">Description of the required product:</label>
                                    <input v-model="form.description"
                                           @blur="$v.form.description.$touch()"
                                           type="text" class="text-input w-input" maxlength="256" name="Finished-Units---Description" data-name="Finished Units - Description" placeholder="i.e. 51mL Squeeze Bottle Gel Hand Sanitizer (75% IPA)" id="Description">
                                    <div class="text-red" v-if="$v.form.description.$error">
                                        <div v-if="!$v.form.description.required">A description is required</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label for="Available-Units" class="input-label">In litres, what volume of finished product do you currently require?</label>
                                    <input v-model="form.qtyRequiredNow"
                                           @blur="$v.form.qtyRequiredNow.$touch()"
                                           type="text" v-mask="'##########'" class="text-input w-input" maxlength="256" name="Finished-Units---Available-Units" data-name="Finished Units - Available Units" placeholder="i.e. 2000" id="Available-Units">
                                    <div class="text-red" v-if="$v.form.qtyRequiredNow.$error">
                                        <div v-if="!$v.form.qtyRequiredNow.required">A value of one or more is required</div>
                                        <div v-if="!$v.form.qtyRequiredNow.minValue">A value of one or more is required</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label for="Production-Rate" class="input-label">In litres, what volume of finished product do you require per week?</label>
                                    <input v-model="form.qtyRequiredIn5Days"
                                           @blur="$v.form.qtyRequiredIn5Days.$touch()"
                                           type="text" v-mask="'##########'" class="text-input w-input" maxlength="256" name="Finished-Units---Production-Rate" data-name="Finished Units - Production Rate" placeholder="i.e. 400" id="Production-Rate">
                                    <div class="text-red" v-if="$v.form.qtyRequiredIn5Days.$error">
                                        <div v-if="!$v.form.qtyRequiredIn5Days.required">A value of one or more is required</div>
                                        <div v-if="!$v.form.qtyRequiredIn5Days.minValue">A value of one or more is required</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label class="input-label">Would you like this request marked as a request for donation?</label>
                                    <label class="w-checkbox checkbox-field">
                                        <input v-model="form.requestForDonation" type="checkbox" id="Request for Donation" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="true">
                                        <span class="checkbox-label w-form-label">Request for Donation</span>
                                    </label>
                                </div>
<!--                                <div class="input-container"><label for="Bottles-Description-6" class="input-label">Add Related File(s) - Optional</label>-->
<!--                                    <div class="w-file-upload">-->
<!--                                        <div class="w-file-upload-default"><input type="file" id="Finished-Units-&#45;&#45;Related-File-2" name="Finished-Units-&#45;&#45;Related-File" data-name="Finished Units - Related File" class="w-file-upload-input"><label for="Finished-Units-&#45;&#45;Related-File-2" class="w-file-upload-label"><div class="w-icon-file-upload-icon"></div><div class="w-inline-block">Upload File</div></label>-->
<!--                                            <div class="w-file-upload-info">Max file size 10MB.</div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-uploading w-hidden">-->
<!--                                            <div class="w-file-upload-uploading-btn"><svg class="w-icon-file-upload-uploading" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 30 30"><path fill="currentColor" opacity=".2" d="M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm0-3a12 12 0 1 0 0-24 12 12 0 0 0 0 24z"></path><path fill="currentColor" opacity=".75" d="M0 15A15 15 0 0 1 15 0v3A12 12 0 0 0 3 15H0z"></path><animatetransform attributename="transform" attributetype="XML" dur="0.6s" from="0 15 15" repeatcount="indefinite" to="360 15 15" type="rotate"></animatetransform></svg>-->
<!--                                                <div class="w-inline-block">Uploading...</div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-success w-hidden">-->
<!--                                            <div class="w-file-upload-file">-->
<!--                                                <div class="w-file-upload-file-name">fileuploaded.jpg</div>-->
<!--                                                <div class="w-file-remove-link">-->
<!--                                                    <div class="w-icon-file-upload-remove"></div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-error w-hidden">-->
<!--                                            <div class="w-file-upload-error-msg" data-w-size-error="Upload failed. Max size for files is 10 MB." data-w-type-error="Upload failed. Invalid file type." data-w-generic-error="Upload failed. Something went wrong. Please retry.">Upload failed. Max size for files is 10 MB.</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="w-file-upload">-->
<!--                                        <div class="w-file-upload-default"><input type="file" id="Finished-Units-Related-File-5" name="Finished-Units-Related-File-2" data-name="Finished Units Related File 2" class="w-file-upload-input"><label for="Finished-Units-Related-File-5" class="w-file-upload-label"><div class="w-icon-file-upload-icon"></div><div class="w-inline-block">Upload File</div></label>-->
<!--                                            <div class="w-file-upload-info">Max file size 10MB.</div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-uploading w-hidden">-->
<!--                                            <div class="w-file-upload-uploading-btn"><svg class="w-icon-file-upload-uploading" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 30 30"><path fill="currentColor" opacity=".2" d="M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm0-3a12 12 0 1 0 0-24 12 12 0 0 0 0 24z"></path><path fill="currentColor" opacity=".75" d="M0 15A15 15 0 0 1 15 0v3A12 12 0 0 0 3 15H0z"></path><animatetransform attributename="transform" attributetype="XML" dur="0.6s" from="0 15 15" repeatcount="indefinite" to="360 15 15" type="rotate"></animatetransform></svg>-->
<!--                                                <div class="w-inline-block">Uploading...</div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-success w-hidden">-->
<!--                                            <div class="w-file-upload-file">-->
<!--                                                <div class="w-file-upload-file-name">fileuploaded.jpg</div>-->
<!--                                                <div class="w-file-remove-link">-->
<!--                                                    <div class="w-icon-file-upload-remove"></div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-error w-hidden">-->
<!--                                            <div class="w-file-upload-error-msg" data-w-size-error="Upload failed. Max size for files is 10 MB." data-w-type-error="Upload failed. Invalid file type." data-w-generic-error="Upload failed. Something went wrong. Please retry.">Upload failed. Max size for files is 10 MB.</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="w-file-upload">-->
<!--                                        <div class="w-file-upload-default"><input type="file" id="Finished-Units-&#45;&#45;Related-File-3" name="Finished-Units-&#45;&#45;Related-File-3" data-name="Finished Units Related File 3" class="w-file-upload-input"><label for="Finished-Units-&#45;&#45;Related-File-3" class="w-file-upload-label"><div class="w-icon-file-upload-icon"></div><div class="w-inline-block">Upload File</div></label>-->
<!--                                            <div class="w-file-upload-info">Max file size 10MB.</div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-uploading w-hidden">-->
<!--                                            <div class="w-file-upload-uploading-btn"><svg class="w-icon-file-upload-uploading" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 30 30"><path fill="currentColor" opacity=".2" d="M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm0-3a12 12 0 1 0 0-24 12 12 0 0 0 0 24z"></path><path fill="currentColor" opacity=".75" d="M0 15A15 15 0 0 1 15 0v3A12 12 0 0 0 3 15H0z"></path><animatetransform attributename="transform" attributetype="XML" dur="0.6s" from="0 15 15" repeatcount="indefinite" to="360 15 15" type="rotate"></animatetransform></svg>-->
<!--                                                <div class="w-inline-block">Uploading...</div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-success w-hidden">-->
<!--                                            <div class="w-file-upload-file">-->
<!--                                                <div class="w-file-upload-file-name">fileuploaded.jpg</div>-->
<!--                                                <div class="w-file-remove-link">-->
<!--                                                    <div class="w-icon-file-upload-remove"></div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="w-file-upload-error w-hidden">-->
<!--                                            <div class="w-file-upload-error-msg" data-w-size-error="Upload failed. Max size for files is 10 MB." data-w-type-error="Upload failed. Invalid file type." data-w-generic-error="Upload failed. Something went wrong. Please retry.">Upload failed. Max size for files is 10 MB.</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div><input v-on:click="submit()" type="button" value="Submit" data-wait="Please wait..." class="submit-button w-button">
                        </form>
                            <div v-if="validation||success||fail" class="form-block w-form">
                                <div class="input-container  form-success" v-if="success">
                                    <div>Thank you! Your submission has been received.<br><br>You will receive a confirmation email
                                        with information on managing your post.
                                    </div>
                                </div>
                                <div class="input-container form-fail" v-if="fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                                <div class="input-container form-fail" v-if="validation">
                                    <div>Please verify that everything you've entered is correct.</div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {formService} from "../../../assets/js/services/formService";
    import {minValue, required} from "vuelidate/lib/validators";

    export default {
        name: "RequestFinishedHandSanitizer",
        data() {
            return {
                form: {
                    qtyRequiredNow: "",
                    qtyRequiredIn5Days: "",
                    qtyRequiredPerMonth: "",
                    description: "",
                    requiredAtStreetAddress: "",
                    requiredInCity: "",
                    requiredInState: "",
                    requiredAtPostalCode: "",
                    requestorType: "",
                    otherRequestorType: "",
                    requestForDonation: false,
                },
                demands: [{
                    requestId: "",
                    productRequest: {
                        id: this.$route.params.id
                    },
                    description: "",
                    qtyRequiredNow: 0,
                    qtyRequiredIn5Days: 0,
                    qtyRequiredPerMonth: 0,
                    requiredAtStreetAddress: "",
                    requiredInCity: "",
                    requiredInState: "",
                    requiredInCountry: "",
                    requiredAtPostalCode: "",
                    msdsLink: "",
                    maximumCostPerUnit: 0,
                    comments: "",
                    ingredientDeliveryMethod: "",
                    ingredientStorage: null,
                    questionStorageAreaRegulatory: "",
                    requestorType: "",
                    offerDonation: "",
                    qtyRequiredNowUnitOfMeasure: "",
                }],
                success: false,
                fail: false,
                validation: false,
                validationMessage: ""
            }
        },
        created () {
            document.title = "Request Finished Units - Hand Sanitizer";//Set the document title
        },
        validations: {
            form: {
                qtyRequiredNow: { required,  minValue: minValue(1) },
                qtyRequiredIn5Days: { required,  minValue: minValue(1) },
                description: { required },
                requiredAtStreetAddress: { required },
                requiredInCity: { required },
                requiredInState: { required },
                requiredAtPostalCode: { required },
                requestorType: {
                    sometimesRequired(requestorType) {
                            if (!requestorType) {//Make sure they entered a value
                                return false;
                            } else if (requestorType == "other") {//If they chose other, make sure they entered something in the text box
                                if (!this.form.otherRequestorType) {
                                    return false;
                                }
                            } else {
                                return true;
                            }
                        return true;
                    }
                }
            },
        },
        methods: {
            submit () {
                this.validation = false;
                this.validationMessage = "";
                this.success = false;
                this.fail = false;

                this.$v.form.$touch();
                if(this.$v.form.$error){
                    this.validation = true;
                    return;
                }

                this.demands[0].qtyRequiredNow = this.form.qtyRequiredNow;
                this.demands[0].qtyRequiredIn5Days = this.form.qtyRequiredIn5Days;
                this.demands[0].qtyRequiredPerMonth = this.form.qtyRequiredPerMonth;
                this.demands[0].description = this.form.description;
                this.demands[0].requiredAtStreetAddress = this.form.requiredAtStreetAddress;
                this.demands[0].requiredInCity = this.form.requiredInCity;
                this.demands[0].requiredInState = this.form.requiredInState;
                this.demands[0].requiredAtPostalCode = this.form.requiredAtPostalCode;

                if (this.form.requestorType == "other"){//Handle other/non-other logic for requestor type
                    this.demands[0].requestorType = this.form.otherRequestorType;
                }
                else{
                    this.demands[0].requestorType = this.form.requestorType;
                }

                if (this.form.requestForDonation == true){//If request for donation is true, make it true. If it's anything else it's false.
                    this.demands[0].offerDonation = true;
                }
                else {
                    this.demands[0].offerDonation = false;
                }

                this.demands[0].qtyRequiredNowUnitOfMeasure = "Litres";// TODO - Pull this value from somewhere?

                console.log(this.form);
                console.log(this.demands[0]);
                formService.requestFinished(this.demands).then(() => {this.success = true;})
                    .catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.validation = true;
                            this.validationMessage = error.content;
                        }
                        else {
                            this.fail = true;
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
